import api from "api/axios";

const BASE = "/admin/speciality-procedures";

export const getSpecialityProcedureCategories = (params) =>
  api.get(`${BASE}/categories`, { params });

export const getSpecialityProcedures = (params) => api.get(BASE, { params });

export const getSpecialityProcedure = (id) => api.get(`${BASE}/${id}`);

export const createSpecialityProcedure = (payload) => api.post(BASE, payload);

export const updateSpecialityProcedure = (id, payload) =>
  api.patch(`${BASE}/${id}`, payload);

export const setSpecialityProcedureStatus = (id, isActive) =>
  api.patch(`${BASE}/${id}/status`, { isActive: Boolean(isActive) });

export const getSpecialityProcedureOptionSuggestions = (params) =>
  api.get(`${BASE}/options`, { params });

export const specialityProcedureSheetApi = {
  /** `kind` is "template" or "export"; the response is the xlsx as a Blob. */
  downloadFile: (kind, params) =>
    api.get(`${BASE}/sheet/${kind}`, { params, responseType: "blob" }),
  importFile: (file) => {
    const body = new FormData();
    body.append("file", file);
    return api.post(`${BASE}/sheet/import`, body, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
};
